/* eslint-disable */
import { Grid } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import {
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_CONFIRMED,
  ORDER_STATUS_DELIVERING,
  ORDER_STATUS_ON_HOLD,
  ORDER_STATUS_TO_BE_CONFIRMED,
} from '../../Constants/Order/Order.constants';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersStatuses from '../../State/Store/Filters/Selectors/FiltersStatus.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_FILTER_ORDER_STATUS_SHOW_ALL } from '../../State/Store/UI/UI.types';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import MoreMenu from '../MoreMenu/MoreMenu.component';
import OrderStatusGroupPropTypes from './OrderStatusGroup.component.props';
import orderStatusGroupStyles from './OrderStatusGroup.component.styles';

const StyledChip = withStyles((theme) => ({
  clickable: {},
  clickableColorPrimary: {},
  clickableColorSecondary: {
    '&:hover, &:focus': {
      backgroundColor: theme.palette.grey[200],
    },
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.text.secondary,
  },
}))(Chip);

/**
 * OrderStatusGroupComponent
 * @export
 * @class OrderStatusGroupComponent
 * @extends {React.Component<OrderStatusGroupComponentComposedProps, OrderStatusGroupComponentState>}
 */
export class OrderStatusGroupComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<OrderStatusGroupComponentProps>}
   * @memberof OrderStatusGroupComponent
   */
  static defaultProps = {
    checkedItems: [],
  };

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderStatusGroup`}
   * @memberof OrderStatusGroupComponent
   */
  static displayName = `OrderStatusGroup`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderStatusGroupComponent
   */
  static propTypes = OrderStatusGroupPropTypes;

  /**
   * The list of possible order statuses to display
   * @type {Array<OrderEntityStatus>}
   * @memberof OrderStatusGroupComponent
   */
  orderStatuses = [
    ORDER_STATUS_TO_BE_CONFIRMED,
    ORDER_STATUS_CONFIRMED,
    ORDER_STATUS_DELIVERING,
    ORDER_STATUS_COMPLETED,
    ORDER_STATUS_CANCELLED,
    ORDER_STATUS_ON_HOLD,
  ];

  /**
   * Get the classes to override the default checkbox tyling
   * @param {OrderEntityStatus} orderStatus The order `status`
   * @returns {Object} The `classes` to use
   * @memberof OrderStatusGroupComponent
   */
  getOrderStatusChipClasses = (orderStatus) => {
    const { classes } = this.props;
    return {
      clickable: classes.clickable,
      clickableColorPrimary: classes[orderStatus],
    };
  };

  /**
   * Toggle a given `name` from within `this.state.checked
   * @param {OrderEntityStatus} orderStatus The name of the item to _toggle_
   * @returns {EventFunction} A bound listener to be consumed by `<ListItem />`'s `onClick` handler
   * @memberof OrderStatusGroupComponent
   */
  handleToggle = (orderStatus) => () => {
    const { checkedItems, actions } = this.props;
    const currentIndex = checkedItems.indexOf(orderStatus);
    const newCheckedItems = [...checkedItems];
    if (currentIndex === -1) {
      newCheckedItems.push(orderStatus);
    } else {
      newCheckedItems.splice(currentIndex, 1);
    }
    actions.filtersStatusSelected(newCheckedItems);
  };

  /**
   * Determine if an item in the sidebar is checked or not
   * @param {OrderEntityStatus} orderStatus The order status to check
   * @returns {boolean} Whether or not the item is checked
   * @memberof OrderStatusGroupComponent
   */
  isChecked = (orderStatus) => {
    const { checkedItems } = this.props;
    return checkedItems.includes(orderStatus);
  };

  /**
   * Show all statuses
   * @returns {void} void
   * @memberof OrderStatusGroupComponent
   */
  showAll = () => {
    const { checkedItems, actions } = this.props;
    actions.uiTriggered({ type: UI_FILTER_ORDER_STATUS_SHOW_ALL });
    const maxOrderStatuses = this.orderStatuses.length;
    const allSelected = checkedItems.length === maxOrderStatuses;
    if (!allSelected) {
      actions.filtersStatusSelected(this.orderStatuses);
    }
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderStatusGroup />`
   * @memberof OrderStatusGroupComponent
   */
  render() {
    const { classes } = this.props;
    const menuItems = [[`order-status-show-all`, this.showAll, <I18n>OrderService.ShowAll</I18n>]];
    return (
      <Card elevation={0} className={classes.sidebarCard}>
        <CardHeader
          action={<MoreMenu menuItems={menuItems} />}
          classes={{ action: classes.sidebarCardHeaderAction, root: classes.sidebarCardHeader }}
          title={<I18n variant="body2">OrderPage.Sidebar.OrderStatus.Heading</I18n>}
        />
        <CardContent>
          <Grid alignItems="baseline" container direction="column" justify="space-evenly">
            {this.orderStatuses.map((orderStatus) => (
              <StyledChip
                classes={this.getOrderStatusChipClasses(orderStatus)}
                clickable
                color={this.isChecked(orderStatus) ? `primary` : `secondary`}
                key={orderStatus}
                label={<I18n data={{ orderStatus }}>OrderService.Status</I18n>}
                onClick={this.handleToggle(orderStatus)}
                onDelete={this.isChecked(orderStatus) ? this.handleToggle(orderStatus) : null}
              />
            ))}
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

/** @type {React.ComponentClass<OrderStatusGroupComponentProps>} */
const OrderStatusGroup = compose(
  withStyles(themeCreateInjectableStyles(orderStatusGroupStyles), { withTheme: true }),
  connect(
    (state) => ({
      checkedItems: getFiltersStatuses(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...filtersActionCreators,
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(OrderStatusGroupComponent);

export default OrderStatusGroup;
